var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "email (4) 1",
    clipPath: "url(#clip0_4484_11119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g453"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g455"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4484_11119",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 19
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipPath461"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path459",
    d: "M0 0.500246H18V18.5002H0V0.500246Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4484_11119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g457"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g463"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path465",
    d: "M0.964163 5.29516C0.691151 5.09945 0.527344 4.77014 0.527344 4.41741V4.41654C0.527344 3.79297 0.997231 3.28746 1.57685 3.28746H15.2279C15.8074 3.28746 16.2773 3.79297 16.2773 4.41654V4.4171V4.41741C16.2773 4.77014 16.1136 5.09945 15.8405 5.29516C14.5084 6.25088 10.4942 9.12986 8.98483 10.2127C8.63206 10.4657 8.17266 10.4657 7.81988 10.2127C6.31049 9.12986 2.29635 6.25088 0.964163 5.29516Z",
    stroke: "#4B5C68",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g467"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path469",
    d: "M0.527344 4.41692V14.5841C0.527344 14.8837 0.637856 15.1709 0.834993 15.3827C1.03187 15.5948 1.29884 15.7137 1.57734 15.7137H15.2273C15.5058 15.7137 15.7728 15.5948 15.9697 15.3827C16.1668 15.1709 16.2773 14.8837 16.2773 14.5841V4.41692",
    stroke: "#4B5C68",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4484_11119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailGray);
export default __webpack_public_path__ + "static/media/emailGray.d2654056149edd126daa3b9f4a0df2a0.svg";
export { ForwardRef as ReactComponent };